import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const createCustomACMGAnnotation = async ({ vcf_file_id, chromosome, position, acmg_annotation, ref, alt }) => {
  try {
    const body = { vcf_file_id, chromosome, position, acmg_annotation }
    if (ref != null) body.ref = ref
    if (alt != null) body.alt = alt
    const response = await axios.post(`${API_BASE_URL}/custom-acmg-annotations/`, body)
    return response
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to create custom ACMG annotation')
  }
}

export const updateCustomACMGAnnotation = async ({
  id,
  vcf_file_id,
  chromosome,
  position,
  acmg_annotation,
  ref,
  alt,
}) => {
  try {
    const body = { vcf_file_id, chromosome, position, acmg_annotation }
    if (ref != null) body.ref = ref
    if (alt != null) body.alt = alt
    const response = await axios.put(`${API_BASE_URL}/custom-acmg-annotations/${id}/`, body)
    return response
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to update custom ACMG annotation')
  }
}

export const deleteCustomACMGAnnotation = async (id) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/custom-acmg-annotations/${id}/`)
    return response
  } catch (error) {
    throw new Error(error.response?.data?.detail || 'Failed to delete custom ACMG annotation')
  }
}
